import { render } from "./DashboardAlumnosView.vue?vue&type=template&id=c500acaa&scoped=true"
import script from "./DashboardAlumnosView.vue?vue&type=script&lang=js"
export * from "./DashboardAlumnosView.vue?vue&type=script&lang=js"

import "./DashboardAlumnosView.vue?vue&type=style&index=0&id=c500acaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c500acaa"]])

export default __exports__